import React from 'react';
import { CtaButton } from './CtaButton';
import { CollectionMockup } from './CollectionMockup';
import { cta, finalClose, price, productName } from '../data/content';
export function FinalCta() {
  return <section className="border-t border-ink-line bg-ink" data-id="element-52" data-mp="19f7ej50uiddd">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:px-6 lg:py-20" data-id="element-53" data-mp="19cmcaewmxvf3">
        <h2 className="font-display text-[1.6rem] font-semibold uppercase leading-[1.1] tracking-tight text-ivory sm:text-[2.6rem]" data-id="element-54" data-mp="15c2gpfrpmzv2">
          {finalClose.titleLines.map(line => <span key={line} className="block" data-id="element-55" data-mp="1ediodfr54nvl">
              {line}
            </span>)}
        </h2>

        <ul className="mx-auto mt-7 max-w-md space-y-2" data-id="element-56" data-mp="1t256tqc2dvr1">
          {finalClose.thoughts.map(thought => <li key={thought} className="font-display text-lg italic leading-snug text-ivory/60 sm:text-xl" data-id="element-57" data-mp="1o67ml8xok58z">
              {thought}
            </li>)}
        </ul>

        <div className="mx-auto mt-9 flex max-w-xs items-center gap-4" aria-hidden="true" data-id="element-58" data-mp="1x64hvteks2d0">
          <span className="h-px flex-1 bg-ink-line" data-id="element-59" data-mp="n6w4cre2zc8i" />
          <span className="h-2 w-2 rotate-45 bg-mustard" data-id="element-60" data-mp="s4fjdtilrt1i" />
          <span className="h-px flex-1 bg-ink-line" data-id="element-61" data-mp="s4xolfn8thlk" />
        </div>

        <p className="mx-auto mt-8 max-w-xl font-display text-[1.35rem] font-semibold uppercase leading-tight tracking-tight text-mustard sm:text-3xl" data-id="element-62" data-mp="x2que7kmw9lb">
          <span className="block" data-id="element-63" data-mp="120io974ua5s5">{finalClose.turnLine1}</span>
          <span className="block" data-id="element-64" data-mp="163xf6subg6kd">{finalClose.turnLine2}</span>
        </p>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-65" data-mp="1b2ruvlwzlf09">
          <CollectionMockup variant="photo" data-id="element-66" data-mp="1b1gqpkzmq58m" />
        </div>

        <p className="mt-7 font-display text-[2rem] font-semibold leading-none tracking-tight text-ivory sm:text-5xl" data-id="element-67" data-mp="1fvbbkrqz0q9a">
          {productName}
        </p>
        <p className="mt-2.5 font-sans text-xs font-bold uppercase tracking-[0.14em] text-ivory/80 sm:text-sm" data-id="element-68" data-mp="1psfywuwjyrro">
          {finalClose.productLine}
        </p>
        <p className="mt-4 font-display text-[clamp(3rem,16vw,4.5rem)] font-semibold leading-none tracking-tight text-mustard sm:text-[5.5rem]" data-id="element-69" data-mp="1tukn3e48ew6x">
          {price}
        </p>

        <p className="mx-auto mt-7 max-w-xl font-display text-[1.45rem] font-semibold uppercase leading-tight tracking-tight text-ivory sm:text-3xl" data-id="element-70" data-mp="3lwndq8hs0scv">
          <span className="block" data-id="element-71" data-mp="3jftmummemkx">{finalClose.headlineLine1}</span>
          <span className="block" data-id="element-72" data-mp="3uuplr7zxgl9n">{finalClose.headlineLine2}</span>
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-73" data-mp="depuhf1a8nx4">
          <CtaButton data-id="element-74" data-mp="dhltl6ov9in5">{cta.primary}</CtaButton>
          <p className="mt-3 font-sans text-xs text-ivory/70 sm:text-sm" data-id="element-75" data-mp="8hhdvivs8rxz">{finalClose.microcopy}</p>
        </div>
      </div>
    </section>;
}